<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import './styles/custom.scss';
#nprogress .bar {
  background: #409EFF !important; //自定义颜色
}
</style>



// WEBPACK FOOTER //
// src/App.vue